import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Reveal, Chapter } from "./Reveal";

const FAQS = [
  {
    q: "How does Revora work?",
    a: "Revora uses NFC technology to let customers tap a card with a compatible smartphone and open your business's designated Google review page.",
  },
  {
    q: "Do I need an app?",
    a: "No app is required for the standard NFC interaction on supported devices. The phone reads the chip and opens the review page directly.",
  },
  {
    q: "How are my products configured?",
    a: "You provide your Google review URL when ordering. Each physical product receives its own unique Revora identity — a permanent Revora link — and we configure it to route customers to your review page before shipping. The chip never contains your Google URL directly.",
  },
  {
    q: "Can I change the review link after ordering?",
    a: "Yes — this is built into how Revora works. Your card's identity is permanent, but its destination is not. Essential and Growth customers edit destinations themselves in the business portal; Starter customers contact us and we update it for you. No new card, no reprogramming — the same physical product sends customers to the new page.",
  },
  {
    q: "Can I use Revora for my business?",
    a: "Yes. Revora products can be used by any business that wants to make it easier for customers to access its Google review page.",
  },
  {
    q: "Does Revora guarantee more reviews?",
    a: "No. Revora provides a convenient way for customers to reach your review page; the decision to leave a review always remains with the customer.",
  },
  {
    q: "What happens if I enter the wrong Google review link?",
    a: "It can be corrected at any time. Because your product's destination is a routing setting — not something permanently burned into the chip — we simply update where it points. Contact us and the same product will route to the corrected page.",
  },
  {
    q: "How long does shipping take?",
    a: "Orders are configured to your business before they ship. Current production and delivery windows are listed on our Shipping Policy page.",
  },
];

export const Faq = () => (
  <section id="faq" className="bg-white py-28 sm:py-36" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-6">
      <Chapter number="10" label="FAQ" />
      <Reveal>
        <h2 className="rvr-title font-display text-4xl md:text-5xl font-bold tracking-tight text-ink leading-[1.05] mb-14">
          Questions, answered
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-black/10" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-display text-lg font-bold text-ink text-left hover:no-underline hover:text-voltdark transition-colors py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-black/55 leading-relaxed pb-6">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
